export const UserTypes = {
  PERSONNEL: 'PERSONNEL',
  PERSONNEL_USERS: 'PERSONNEL_USERS',
  B2B_PERSONNEL: 'B2B_PERSONNEL',
  B2B_USER: 'B2B_USER',
  USER: 'USER',
  ADMIN: 'ADMIN',
  ANONYMOUS: 'ANONYMOUS',
  PERSONNEL_PACKAGES: 'PERSONNEL_PACKAGES'
}

export const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const B2B_RULE_TYPES = [
  'B2B_HS_CODE_COUNT',
  'B2B_HS_CODE_SET',
  'B2B_SEARCH_COUNTRY_SET',
  'B2B_CAMPAIGN_COUNT',
  'B2B_TOTAL_EMAIL_COUNT',
  'B2B_PRODUCT_DETAIL_SEARCH_COUNT',
  'AI_REL_CHECK',
  'AI_EMAIL_GEN',
  'CONTACT_FIRM_SEARCH',
  'CONTACT_EMAIL_SEARCH',
  'ALL_FIRM_DOWNLOAD_COUNT',
  'TRADE_REGISTRY_FIRM_VIEW_COUNT',
  'MARKET_REPORT_EXCEL_DOWNLOAD_COUNT',
  'MARKET_REPORT_DAILY_SEARCH_COUNT',
  'EXCEL_EXPORT_NOT_ALLOWED_FOR_STATUS',
  'EXCEL_EXPORT_BUSINESS_ERROR',
  'ExcelGeneratorExceptionDetail'
]
